const convertDate = (date?: number): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toISOString().split("T")[0];
};

const convertDateIso = (date?: string): string => {
  if (date == undefined) {
    return "";
  }
  return new Date(date).toISOString().split("T")[0];
};

const convertDateBrComHora = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleString("en-GB");
};

const convertDateBr = (date?: number) => {
  if (date == undefined) {
    return "";
  }

  const myDate = new Date(date * 1000);
  return (
    (myDate.getUTCDate() + "").padStart(2, "0") +
    "/" +
    (myDate.getUTCMonth() + 1 + "").padStart(2, "0") +
    "/" +
    myDate.getUTCFullYear()
  );
  // return new Date(date * 1000).toLocaleDateString("en-GB");
};

const convertDateUs = (date?: number) => {
  if (date == undefined) {
    return "";
  }
  return new Date(date * 1000).toLocaleDateString();
};

const convertStringDateToBr = (date?: string) => {
  if (date == undefined) {
    return "";
  }
  const [year, month, day] = date.split("-");
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};

const getFullYear = () => {
  const dataAtual = new Date();
  return dataAtual.getFullYear();
};

const convertTimeStampToDate = (timestamp?: number) => {
  if (timestamp == undefined) {
    return "";
  }
  const data = new Date(timestamp * 1000);
  return data.toISOString().split("T")[0];
};

const tomorrowDate = () => {
  const tomorrow = new Date();
  const timestamp = tomorrow.setDate(tomorrow.getDate() + 1);
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();

  return year + "-" + month + "-" + day;
};

const convertDdMmYyyyToIso = (date?: string): string => {
  if (!date || date.length !== 8) return "";

  const day = date.slice(0, 2);
  const month = date.slice(2, 4);
  const year = date.slice(4, 8);

  // Retorna no formato ISO (yyyy-MM-dd)
  return `${year}-${month}-${day}`;
};

const convertDdMmYyyyToBr = (date?: string): string => {
  if (!date || date.length !== 8) return "";

  const day = date.slice(0, 2);
  const month = date.slice(2, 4);
  const year = date.slice(4, 8);

  // Retorna no formato brasileiro (dd/MM/yyyy)
  return `${day}/${month}/${year}`;
};

// Nova função específica para converter timestamp para data brasileira
const convertTimestampToBr = (timestamp?: number | string): string => {
  if (timestamp == undefined) {
    return "";
  }

  // Converte string para número se necessário
  const timestampNum =
    typeof timestamp === "string" ? parseInt(timestamp) : timestamp;

  // Verifica se é um timestamp válido
  if (isNaN(timestampNum)) {
    return "";
  }

  const date = new Date(timestampNum * 1000);

  // Verifica se a data é válida
  if (isNaN(date.getTime())) {
    return "";
  }

  const day = date.getUTCDate().toString().padStart(2, "0");
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
};

export {
  convertDate,
  convertDateIso,
  convertDateBr,
  convertDateUs,
  convertStringDateToBr,
  getFullYear,
  tomorrowDate,
  convertDateBrComHora,
  convertTimeStampToDate,
  convertDdMmYyyyToIso,
  convertDdMmYyyyToBr,
  convertTimestampToBr, // Nova função
};
